import { render } from "./ResultsPagination.vue?vue&type=template&id=9c9373ca"
import script from "./ResultsPagination.vue?vue&type=script&lang=js"
export * from "./ResultsPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__